// The client half of the RUM intake relay: the URL the browser SDK posts a
// batch to when its `proxy` option is the function this module builds.
//
// The SDK calls the function with its own intake path and query parameters.
// They travel to the relay as one encoded `ddforward` value, beside the
// Datadog site the client token belongs to, so a relay serving several sites
// picks the intake host from its fixed site map rather than from the request.

/** Query parameter carrying the SDK's encoded `<path>?<parameters>`. */
export const RELAY_TARGET_PARAM = 'ddforward';
/** Query parameter carrying the encoded Datadog site the client is configured for. */
export const RELAY_SITE_PARAM = 'dd-site';

export interface SdkProxyOptions {
  readonly path: string;
  readonly parameters: string;
}

export function rumRelayProxy(
  relayUrl: string,
  site: string,
): (options: SdkProxyOptions) => string {
  return ({ path, parameters }) =>
    `${relayUrl}?${RELAY_SITE_PARAM}=${encodeURIComponent(site)}&${RELAY_TARGET_PARAM}=${encodeURIComponent(`${path}?${parameters}`)}`;
}
